/*
Akhila 12/21/2022 3075154998 Added select Field Screen
Sohel 12/21/2022 3075154998 Fixed Category Populate Issue
Sohel 12/23/2022 3075154998 Added Delete selected Fields popup
Sohel 03/01/2023 3075154998 removed Category Column
Sohel 01/10/2023 2698964415 Added disable conditions in Fields.
Sohel 01/13/2023 2698964415 Field Type Value Changes
Sohel 01/16/2023 2698959212 added reset button
Sohel 01/17/2023 2698959212 table changes
Sohel 01/17/2023 2698959212 Added Temp Field in fields
Sohel 01/17/2023 2698959212 Added Function Fields
Sohel 01/17/2023 2698964415 change popup delete message
Sohel 01/18/2023 2698964415 change popup title message
Suresh Peddavoora 01/18/2023 2698964415 Fixed SelectFields Width Alignments
Sohel 01/20/2023 2698964415 changed dropdown values
Lalitha 01/23/2023 2698964415 fixed deleted popup messege issue
Sohel 01/23/2023 2698964415 Added Audit Fields
Ravi 01/27/2023 2698964415 fixed tooltip issue
Sohel 02/13/2023 2701335619 fixed unique field validation issue
Sohel 02/17/2023 2701335619 fixed Function Date Format Issue
Sohel 02/20/2023 2701335619 Function Date Format Changes
Rohini 02/28/2023 2701335619 Added class name for the table field
Sohel 03/28/2023 2701335619 processor fields added logic field
Sohel 04/19/2023 2698964415 Added Data Calculation Field
Sohel 04/24/2023 2701335619 Added Summary Fields
Akhila 06/12/2023 2698964415 added role access
Sohel 06/19/2023 2701335619 change Temp Repo and Function repository name
Sohel 06/21/2023 2701335619 Fixed disabled Issue
Phanee 08/01/2023 2701335619 Fixed delete popup message issue
*/
import React, {useState, useRef} from 'react';
import {FormControl, IconButton, MenuItem, Select, TextField, Tooltip} from '@material-ui/core';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {DeleteOutlined} from '@material-ui/icons';
import {withField} from './RecordFormatFieldsComponents/withField';
import {ErrorTooltip} from '../../../../../components/Tooltips';
import {getIn} from 'formik';
import {NumberFormatter} from '../../../../../components/UserDefinedForm/AppTextInputComponents';
import {upperCaseCode} from '../../../../../components/UpperCaseCode';
export const showValue = (current) =>
  current.processorFieldType === 'Function' &&
  current.processorFieldName &&
  ['FIXED_TEXT', 'DATE', 'TIME', 'DATE_TIME'].includes(current.processorFieldName);

function DMRSelectFieldsTable(props) {
  const [isDelete, setIsDelete] = useState(false);
  const deletedFieldName = useRef('');
  const {
    name,
    setFieldValue,
    errors,
    touched,
    value: current,
    index,
    values,
    key,
    dmArrayHelpers,
    deletedProcessorFields,
    functionsList,
    editExisting,
    dmTempRecordAccess,
    exportRecordGroupAccess,
    importRecordGroupAccess,
  } = props;
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const codeRef = useRef();
  const handleSubmit = () => {
    dmArrayHelpers.current.remove(index);

    const ids = [
      ...deletedProcessorFields.current,
      values?.selectedFields[index]?.processorId ? values?.selectedFields[index]?.processorId : 0,
    ];
    deletedProcessorFields.current = ids;
    handleDeleteClose();
  };
  const dataTypes = ['Number', 'Text', 'Email', 'Amount', 'SSN', 'Phone', 'Date'];
  const currFunctionDataType = functionsList.filter(
    (el) => el.value === current.processorFieldName,
  )[0]?.dataType;
  const currentFieldError = (currFieldName) =>
    getIn(touched, name + '.' + currFieldName) ? getIn(errors, name + '.' + currFieldName) : '';

  return (
    <>
      <tr key={key}>
        <td className="recFormat-col recFormat-center new-standard-textfields ">
          <Tooltip title="Delete">
            <IconButton
              onClick={() => {
                setIsDelete(true);
                deletedFieldName.current =
                  current.processorFieldType === 'Temp Field' ||
                  current.processorFieldType === 'Summary Field';
                current.processorFieldType === 'Function' ?
                  current.processorFieldName :
                  current.fieldName;
              }}
              disabled={
                current.tabType === 'Record Format Field' ||
                (editExisting &&
                  (dmTempRecordAccess?.edit === false ||
                    exportRecordGroupAccess?.edit === false ||
                    importRecordGroupAccess?.edit === false))
              }
            >
              <DeleteOutlined />
            </IconButton>
          </Tooltip>
        </td>
        <td className="recFormat-col global-field-textfields ">
          {current?.tabType === 'Record Format Field' ?
            current?.fieldType :
            current?.processorFieldType}
        </td>
        <td className="recFormat-col global-field-textfields new-standard-textfields ">
          {current.repositoryName}
        </td>
        <td className="recFormat-col global-field-textfields">
          {['Temp Field', 'Summary Field']?.includes(current.processorFieldType) &&
            current?.tabType !== 'Record Format Field' && (
            <ErrorTooltip
              title={
                currentFieldError('processorFieldName')?.length > 0 ?
                  currentFieldError('processorFieldName') :
                  ''
              }
            >
              <TextField
                margin="dense"
                type="text"
                variant="outlined"
                className="textfield-block"
                InputLabelProps={{
                  shrink: true,
                }}
                name={name + '.processorFieldName'}
                error={currentFieldError('processorFieldName')}
                value={current.processorFieldName}
                inputRef={codeRef}
                onChange={(e) => {
                  const value = upperCaseCode(codeRef);
                  setFieldValue(name + '.processorFieldName', value?.replaceAll(' ', '_'));
                }}
              />
            </ErrorTooltip>
          )}
          {(current?.tabType === 'Record Format Field' ||
            current.fieldType === 'DB Field' ||
            current.processorFieldType === 'DB Field' ||
            current.processorFieldType === 'Audit Field' ||
            current.processorFieldType === 'Data Calculation Field') &&
            current.fieldName}
          {current.processorFieldType === 'Function' && current?.tabType !== 'Record Format Field' && (
            <ErrorTooltip
              title={
                currentFieldError('processorFieldName')?.length > 0 ?
                  currentFieldError('processorFieldName') :
                  ''
              }
            >
              <FormControl
                margin="dense"
                variant="outlined"
                fullWidth
                className="recFormat-select-field"
              >
                <Select
                  fullWidth
                  name={name + '.processorFieldName'}
                  className="select-gender"
                  value={current.processorFieldName}
                  placeholder="Function"
                  error={currentFieldError('processorFieldName')}
                  onChange={(e) => {
                    setFieldValue(name + '.processorFieldName', e.target.value);
                  }}
                >
                  <MenuItem value="none" key="none" disabled>
                    <span className="defaultSelected">Select Any</span>
                  </MenuItem>
                  {functionsList.map((sep) => (
                    <MenuItem value={sep.value} key={sep.value}>
                      {sep.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </ErrorTooltip>
          )}
        </td>
        <td className="recFormat-col global-field-textfields export-dateField">
          {current.processorFieldType === 'Temp Field' ||
          current.processorFieldType === 'DB Field' ||
          current.processorFieldType === 'Audit Field' ||
          current.processorFieldType === 'Summary Field' ||
          current.processorFieldType === 'Data Calculation Field' ? (
              '-'
            ) : showValue(current) &&
            current.processorFieldName === 'DATE' &&
            current?.tabType !== 'Record Format Field' ? (
                <ErrorTooltip
                  title={
                    currentFieldError('fieldValue')?.length > 0 ? currentFieldError('fieldValue') : ''
                  }
                >
                  <TextField
                    margin="dense"
                    type="text"
                    variant="outlined"
                    placeholder={`Value`}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={currentFieldError('fieldValue')}
                    name={name + '.fieldValue'}
                    value={current.fieldValue}
                    onChange={(e) => {
                      setFieldValue(name + '.fieldValue', e.target.value);
                    }}
                    InputProps={{
                      startAdornment: (
                        <Select
                          name={name + '.dateType'}
                          className="select-gender"
                          value={current.dateType}
                          onChange={(e) => {
                            setFieldValue(name + '.dateType', e.target.value);
                          }}
                        >
                          {['T + ', 'T - '].map((sep) => (
                            <MenuItem value={sep} key={sep}>
                              {sep}
                            </MenuItem>
                          ))}
                        </Select>
                      ),
                      inputComponent: NumberFormatter,
                    }}
                  />
                </ErrorTooltip>
              ) : showValue(current) &&
            current.processorFieldName !== 'DATE' &&
            current?.tabType !== 'Record Format Field' ? (
                  <ErrorTooltip
                    title={
                      currentFieldError('fieldValue')?.length > 0 ? currentFieldError('fieldValue') : ''
                    }
                  >
                    <TextField
                      margin="dense"
                      type="text"
                      variant="outlined"
                      placeholder={`Value`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={currentFieldError('fieldValue')}
                      name={name + '.fieldValue'}
                      value={current.fieldValue}
                      onChange={(e) => {
                        setFieldValue(name + '.fieldValue', e.target.value);
                      }}
                    />
                  </ErrorTooltip>
                ) : current?.tabType === 'Record Format Field' ? (
                  current?.fieldValue
                ) : (
                  '-'
                )}
        </td>
        <td className="recFormat-col global-field-textfields">
          {['Temp Field', 'Summary Field']?.includes(current.processorFieldType) &&
            current?.tabType !== 'Record Format Field' && (
            <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
              <Select
                fullWidth
                name={name + '.dataType'}
                className="select-gender"
                value={current.dataType}
                placeholder="Data Type"
                onChange={(e) => {
                  setFieldValue(name + '.dataType', e.target.value);
                }}
              >
                <MenuItem value="none" key="none" disabled>
                  <span className="defaultSelected">Select Any</span>
                </MenuItem>
                {dataTypes.map((sep) => (
                  <MenuItem value={sep} key={sep}>
                    {sep}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {(current?.tabType === 'Record Format Field' ||
            current.fieldType === 'DB Field' ||
            current.processorFieldType === 'DB Field' ||
            current.processorFieldType === 'Audit Field' ||
            current.processorFieldType === 'Data Calculation Field') &&
            current.dataType}
          {current.processorFieldType === 'Function' &&
            current?.tabType !== 'Record Format Field' &&
            currFunctionDataType}
        </td>
      </tr>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Transformation Field"
        value={`Are you sure you want to delete the ${current.processorFieldName || current.fieldName} Transformation Field ?`}
        handleSubmit={handleSubmit}
      />
    </>
  );
}
export default withField(DMRSelectFieldsTable);
